import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";  
import { Grid } from "@material-ui/core"; 
import { Card } from "reactstrap";  
import { Icon } from "@progress/kendo-react-common";
import { LoadingPanel } from "../../../CommonComponents/CommonFunction";

const EmployeeDetail = ({ 
  userInfo, 
  EmployeeStatuses,
  isloading,
  price,
  setPrice, 
  empCertifications, 
  leaveShareDisplay, 
  getRulesValue,
  leaveHours,
  leaveHoursTR,
  isleaveShare = true,
  oldRate =0,
}) => { 
  
  const { role: selectedRole } = useSelector((state) => state.CommonReducer);


  const [stickySwitch, setStickySwitch] = useState(false); 
  const [isOpenTagModal, setIsOpenTagModal] = useState(false);
  const [openCountModal, setOpenCountModal] = useState(false);
  const [leaveName, setLeavename] = useState("")

  useEffect(() => {
     
    if (EmployeeStatuses && EmployeeStatuses.length > 0) {
      setPrice(EmployeeStatuses[0]["HourlyRate"]);
    } else {
      if (userInfo && userInfo.Rate) {
        setPrice(userInfo.Rate.toFixed(2));
      } else {
        setPrice(0);
      }
    }
  }, [EmployeeStatuses, userInfo]);  
 
  useEffect(() => {
    document.addEventListener("DOMContentLoaded", function () {
      const stickyElement = document.querySelector(".myStickyDiv");
      const container = document.querySelector(".MainDivForSticky");

      window.addEventListener("scroll", function () {
        const containerRect = ""; //container.getBoundingClientRect();
        if (containerRect.top <= 0) {
          stickyElement.classList.add("sticky");
          setStickySwitch(true);
        } else {
          stickyElement.classList.remove("sticky");
          setStickySwitch(false);
        }
      });
    });
  }, [window]);


  return (
    <>
      <div className="gap-16  myStickyDiv">
        <Card elevation={4} className=" p-10  mb-10 " >
          {isloading && <LoadingPanel></LoadingPanel>}
           
          <Grid container spacing={2}>
            <Grid item className="mx-1">
              <div className="">
                <Typography className="text-14 font-semibold pl-2 pt-1 ">

                  <Icon className="m-r-5" name="user" />
                  <b>Name </b>
                  <span className="textempfweight"> : {userInfo ? userInfo.EmployeeName : ""}</span>
                </Typography>
              </div>
            </Grid>
            <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1 ">
                   
                  <Icon className="m-r-5" name="envelop" />

                  <b className="">Employee No</b>
                  <span className="textempfweight"> :
                    {userInfo ? userInfo.ID : ""}</span>
                </Typography>
              </div>
            </Grid>
            {oldRate !==  0 ? 
            <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1  ">
                  <Icon className="m-r-5" name="dollar" />

                  <b className="">Old Rate</b>
                  <span className="textempfweight"> : {`$ ${oldRate}`}</span>
                </Typography>
              </div>
            </Grid> : null }
            <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1  ">
                  <Icon className="m-r-5" name="dollar" />

                  <b className="">Rate</b>
                  <span className="textempfweight"> : {`$ ${price}`}</span>
                </Typography>
              </div>
            </Grid> 
            <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1  ">
                  <Icon className="m-r-5" name="user" />

                  <b className="">Divison No. / Name</b>
                  <span className="textempfweight"> : {
                    userInfo
                      ? `${userInfo?.employeeInfo?.divNo ? userInfo?.employeeInfo?.divNo : "-"} / ${userInfo?.employeeInfo?.divName ? userInfo?.employeeInfo?.divName :"-"}`
                      : "-"
                  }</span>
                </Typography>
              </div>
            </Grid>

            <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1 ">
                  <Icon className="m-r-5" name="user" />

                  <b className=""> Position </b>
                  <span className="textempfweight"> : {
                    userInfo?.employeeInfo?.employeePositionTitle
                      ? userInfo?.employeeInfo?.employeePositionTitle
                      : "-"
                  }</span>
                </Typography>
              </div>
            </Grid>
            


            <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1  ">
                  <Icon className="m-r-5" name="warning" />

                  <b className="">Exempt Flag</b> : {' '}
                  <span className="textempfweight">

                    {userInfo?.exemptFlag ? userInfo?.exemptFlag : 'N/A'}

                  </span>
                </Typography>
              </div>
            </Grid>
          
              <Grid item className="mx-1">
              {" "}
              <div className="">
                <Typography className="text-14  font-semibold pl-2 pt-1 ">
                  <Icon className="m-r-5" name="user" />

                  <b className=""> JobOrder No </b>
                  <span className="textempfweight"> : {
                    userInfo?.empJobOrderNumber
                      ? userInfo?.empJobOrderNumber
                      : "-"
                  }</span>
                </Typography>
              </div>
            </Grid>  
          </Grid> 
        </Card>
       
      </div>
      
    </>
  );
};

export default EmployeeDetail;